import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_ESIGN_AUTH_KEY } from '../../../sessionStorage'

export default function Sign(props) {

  const { path } = useParams();
  const [iframeUrl, setIframeUrl] = useState("");

  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  let passcode = props.SSNNumber ? props.formState.steps.agreementToUnderwriting.socialSecurityNumber.replace(/-/g, '').substring(5) : props.formState.steps.identityVerification.socialSecurityNumber.replace(/-/g, '').substring(5);
  let birthdate = props.formState.steps.basicInfo.birthdate;
  let applicationID = props.formState.appIdentifier;

  useEffect(() => {

    // TODO when coming back from esign but formState still points to sign instead of status - routing can be improved
    if (path && path === 'status') {
      return;
    }

    const esignAuth = sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY) && JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY));
    if (esignAuth) {
      passcode = esignAuth.passcode;
      birthdate = esignAuth.birthdate;
      applicationID = esignAuth.applicationID;
    }

    const returnPath = props.redirectPath;

    fetch(`${covrServicesUrl}/api/ESign/GetEsignIframeUrl?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}&esignReturnPath=${returnPath}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(json => {
        setIframeUrl(json);
      })
  }, []);


  return (
    <Container>
      <Row>
        <Col>
          {iframeUrl &&
            <iframe src={iframeUrl} height="1000px" width="100%" scrolling="auto" frameBorder="0" title="Sign your application with Docusign" name='docusign-iframe' id='docusign-iframe'/>
          }

          {!iframeUrl &&
            <div className='d-flex justify-content-center'><CircularProgress /></div>
          }
        </Col>
      </Row>
    </Container>
  )
}

Sign.propTypes = {
  formState: PropTypes.object.isRequired,
}
